import { queryLocalPublicReviews } from './api';
import { denormalisedEntities, updatedEntities } from './data';

const createdAt = r => r?.attributes?.createdAt?.getTime?.() || 0;

// A reference to something not in the response leaves that relationship empty instead of
// dropping every review.
const reviewsOf = response => {
  const body = response?.data || {};
  const data = Array.isArray(body.data) ? body.data : [];
  return data.length ? denormalisedEntities(updatedEntities({}, body), data, false) : [];
};

/**
 * Adds published reviews on local orders (our order engine, not in Sharetribe) to Sharetribe's,
 * newest first. If they cannot be loaded, Sharetribe's reviews are shown alone. Not on the server:
 * the API client needs the browser's fetch.
 * @param {Array} sharetribeReviews denormalised reviews from sdk.reviews.query
 * @param {{ listingId: string }|{ subjectId: string }} params
 */
export const withLocalReviews = (sharetribeReviews, params) => {
  if (typeof window === 'undefined') return Promise.resolve(sharetribeReviews);
  return queryLocalPublicReviews(params)
    .then(reviewsOf)
    .catch(e => {
      console.warn('Local reviews could not be loaded', e);
      return [];
    })
    .then(local => {
      if (!local.length) return sharetribeReviews;
      const seen = new Set(sharetribeReviews.map(r => r.id.uuid));
      return [...sharetribeReviews, ...local.filter(r => !seen.has(r.id.uuid))].sort(
        (a, b) => createdAt(b) - createdAt(a)
      );
    });
};
